<template>
  <v-container>
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <!--<img :src="singleVolunteer.unpaid.image" alt="" width="100%" class="img-rounded">-->
        <br>
        <br>
        <h3 class="text-lg-center text-md-center text-sm-center earth-color" style="text-decoration: underline ">{{singleVolunteer.unpaid.program}}</h3>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12 v-for="(image, key) in singleVolunteer.unpaid.images" :key="key">
            <img :src="image.image" alt="" width="100%" class="img-rounded">
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg6 sm6 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-container>
              <img :src="singleVolunteer.unpaid.image" alt="" width="100%" class="img-rounded">
              <br/>
              <br/>
              <span v-html="singleVolunteer.unpaid.description"></span>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 sm6 sm12 xs12>
        <v-container>
          <v-card flat>
            <v-tabs ripple>
              <v-tab ripple key="equity" v-if="singleVolunteer.unpaid.currency === 'KES'"><h5 class="earth-color" v-if="$paymentOptions[2].active === true && singleVolunteer.unpaid.currency === 'KES'">EQUITY</h5></v-tab>
              <v-tab ripple key="iveri"><h5 class="earth-color" v-if="$paymentOptions[0].active === true">IVERI</h5></v-tab>
              <v-tab-item key="equity" v-if="singleVolunteer.unpaid.currency === 'KES'">
                <v-container>
                  <br>
                  <h2 class="text-lg-center text-md-center text-sm-center earth-color">VOLUNTEER PROGRAM PAYMENT</h2>
                  <h4 class="text-lg-center text-md-center text-sm-center earth">KES {{singleVolunteer.unpaid.price * 100}}</h4>
                  <div class="col-md-12 text-center">
                    <form id="eazzycheckout-payment-form" action=" https://api-test.equitybankgroup.com/v2/checkout/launch" method="POST">
                      <input type="hidden" id="token" name="token" :value="$JengaAuth['payment_token']">
                      <input type="hidden" id="amount" name="amount" :value="_amount">
                      <input type="hidden" id="orderReference" name="orderReference" :value="singleVolunteer.public_id">
                      <input type="hidden" id="merchantCode" name="merchantCode" value="6695472063">
                      <input type="hidden" id="merchant" name="merchant" value="Ol Pejeta Conservancy" >
                      <input type="hidden" id="custName" name="custName" :value="singleVolunteer.full_name">
                      <input type="hidden" id="outletCode" name="outletCode" value="8819727279">
                      <input type="hidden" id="popupLogo" name="popupLogo">
                      <input type="hidden" id="ez1_callbackurl" name="ez1_callbackurl">
                      <input type="hidden" id="ez2_callbackurl" name="ez2_callbackurl">
                      <input type="hidden" id="expiry" name="expiry" value="2025-02-17T19:00:00">
                      <v-btn type="submit" id="submit-cg" role="button" class="btn btn-primary col-md-4 text-center" value="Checkout" color="primary" target="_blank">Checkout</v-btn>
                    </form>
                    <p>* This is a KES based checkout</p>
                  </div>
                </v-container>
              </v-tab-item>
              <v-tab-item key="iveri">
                <v-container>
                  <div class="">
                    <br>
                    <h2 class="text-lg-center text-md-center text-sm-center earth-color">VOLUNTEER PROGRAM PAYMENT</h2>
                    <h4 class="text-lg-center text-md-center text-sm-center earth">{{singleVolunteer.unpaid.currency}} {{singleVolunteer.unpaid.price}}</h4>
                    <div class="col-md-10 " style="margin-left: 15%; width: 70%">
                      <div class="container-fluid ">
                        <div class="col-md-12">
                          <div class="">
                            <div class="">
                              <form id="myform" name="myform" METHOD="POST" ACTION="https://portal.host.iveri.com/Lite/Authorise.aspx">
                                <!-- Mandatory form variables  -->
                                <input v-if="singleVolunteer.unpaid.currency === 'USD'" id="Lite_Merchant_Applicationid" name="Lite_Merchant_Applicationid" type="hidden" :value="live_id" readonly="true">
                                <input v-if="singleVolunteer.unpaid.currency === 'KES'" id="Lite_Merchant_Applicationid" name="Lite_Merchant_Applicationid" type="hidden" :value="kes_live_id" readonly="true">
                                <input id="Lite_Order_Amount" name="Lite_Order_Amount" type="hidden" :value="_amountUSD" readonly="true">
                                <input type="hidden" name="Lite_Website_Successful_url" :value="iveri_catcher_url + 'volunteer-payment'" /> <!-- NEED TO BE CHANGED -->
                                <input type="hidden" name="Lite_Website_Fail_url" :value="iveri_url + '/program-payment/'+singleVolunteer.public_id" /> <!-- NEED TO BE CHANGED -->
                                <input type="hidden" name="Lite_Website_TryLater_url" :value="iveri_url + '/program-payment/'+singleVolunteer.public_id"  /> <!-- NEED TO BE CHANGED -->
                                <input type="hidden" name="Lite_Website_Error_url" :value="iveri_url + '/program-payment/'+singleVolunteer.public_id"  /> <!-- NEED TO BE CHANGED -->
                                <input id="Lite_Currency_AlphaCode" name="Lite_Currency_AlphaCode" type="hidden" :value="singleVolunteer.unpaid.currency" readonly="true">
                                <input id="Lite_Order_LineItems_Product_1" name="Lite_Order_LineItems_Product_1" type="hidden" :value="singleVolunteer.unpaid.program" readonly="true">
                                <input id="Lite_Order_LineItems_Quantity_1" name="Lite_Order_LineItems_Quantity_1" type="hidden" value="1" readonly="true">
                                <input id="Lite_Order_LineItems_Amount_1" name="Lite_Order_LineItems_Amount_1" type="hidden" :value="_amountUSD" readonly="true">
                                <input id="Lite_ConsumerOrderID_PreFix" name="Lite_ConsumerOrderID_PreFix" type="hidden" value="DML" readonly="true">
                                <input id="Ecom_BillTo_Online_Email" name="Ecom_BillTo_Online_Email" type="hidden" :value="singleVolunteer.email">
                                <input id="Ecom_Payment_Card_Protocols" name="Ecom_Payment_Card_Protocols" type="hidden" value="iVeri" readonly="true">
                                <input id="ApplicationId" name="ApplicationId" type="hidden" :value="singleVolunteer.latest_application">
                                <input id="Ecom_TransactionComplete" name="Ecom_TransactionComplete" type="hidden" value="" readonly="true">
                                <!-- End-->
                                <font color="red"><p class="warningtext" id="warning" name="warning" >&nbsp;</p></font>
                                <li>
                                  <v-text-field
                                    v-model="singleVolunteer.email"
                                    :rules="requiredRules"
                                    label="Email"
                                    required
                                    name="txtEmail"
                                  ></v-text-field>
                                  <!--<input type="text" autocomplete="off" id="txtEmail" name="txtEmail" class="form-control" :value="singleVolunteer.email" placeholder="Email"><a href="#" class=" icon user" tabindex="-1" ></a>-->
                                </li>
                                <li>
                                  <input type="text" id="Amount" hidden="hidden" name="Amount" class="text"  :value="_amount"><a href="#" class=" icon user" tabindex="-1"></a>
                                </li>

                                <br>
                                <div class="submit">
                                  <v-btn :depressed="true" type="submit" id="btnsubmit" block name="btnsubmit"  color="primary">Proceed to Card Payment</v-btn>
                                  <!--<input type="submit" id="btnsubmit" class="btn primary btn-block" name="btnsubmit"  value="Proceed to Card Payment" >-->
                                  <br>
                                  <br>
                                  <p>Please re-confirm your email address to proceed with Volunteer Program payment.</p>
                                  <div class="clear">  </div>
                                </div>

                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'program-payment',
  data () {
    return {
      publicId: this.$route.params.program_id
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_payment_platforms')
    this.$store.dispatch('get_jenga_auth')
  },
  created () {
    this.$store.dispatch('get_volunteer', this.$route.params.program_id)
  },
  methods: {
    checkIfPaid () {
      if (this.singleVolunteer.payment_status === 'Paid') {
        this.$router.push({
          name: 'SuccessVolunteer'
        })
      }
    }
  },
  computed: {
    _amountUSD () {
      if (this.singleVolunteer.hasOwnProperty('payment_status')) {
        this.checkIfPaid()
        if (this.singleVolunteer.unpaid.currency === 'USD') {
          return this.singleVolunteer.unpaid.price * 100
        } else {
          if (this.singleVolunteer.unpaid.currency === 'USD') {
            return this.singleVolunteer.unpaid.price * 100
          } else {
            return this.convert2(this.singleVolunteer.unpaid.currency, 'USD', this.singleVolunteer.unpaid.price * 100).raw_amount
          }
        }
      }
    },
    _amount () {
      if (this.singleVolunteer.hasOwnProperty('payment_status')) {
        this.checkIfPaid()
        if (this.singleVolunteer.unpaid.currency === 'USD') {
          return this.singleVolunteer.unpaid.price * 10000
        } else {
          if (this.singleVolunteer.unpaid.currency === 'USD') {
            return this.singleVolunteer.unpaid.price * 10000
          } else {
            return this.convert2(this.singleVolunteer.unpaid.currency, 'USD', this.singleVolunteer.unpaid.price).raw_amount
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  li {
    text-decoration: none;
    list-style: none;
  }
</style>
